import airtimeSessions from '../images/ZebSolo.jpg'
import bullMoose from '../images/MarshSolo.jpg'
import soberAlbum from '../images/JohnSolo.jpg'
import jacobSolo from '../images/JacobSolo.jpg'

const sliderData = [
  {
    title: 'John Duncan',
    image: soberAlbum,
    id: '1',
    year: 'Aug 2021',
    link: 'https://jacksongrimm.bandcamp.com/album/sober-again',
    description: 'John Duncan',
  },
  {
    title: 'Marshall Brown',
    image: bullMoose,
    id: '12',
    year: 'Nov 2018',
    link: 'https://jacksongrimm.bandcamp.com/album/the-bull-moose-party',
    description: 'Marshall Brown',
  },
  {
    title: 'Zeb Gambill',
    image: airtimeSessions,
    id: '3',
    year: 'Jan 2016',
    link: 'https://jacksongrimm.bandcamp.com/album/the-airtime-sessions',
    description: 'Zeb Gambill',
  },
  {
    title: 'Jacob Brewer',
    image: jacobSolo,
    id: '4',
    year: 'Jan 2016',
    link: 'https://jacksongrimm.bandcamp.com/album/the-airtime-sessions',
    description: 'Jacob Brewer',
  },
]

export default sliderData
